<script lang="ts">
	export let placeholder = "";
	export let displayText = "";

</script>

<button on:click>
	{#if displayText}
		<span class="display">{displayText}</span>
	{:else}<span class="placeholder">{placeholder}</span>{/if}
</button>

<style lang="scss">
	button {
		width: 100%;
		padding: 10px;
		padding: 10px;
		box-sizing: border-box;
		background-color: white;
		border: none;
		border-radius: 5px;
		height: 40px;
		font-size: 1.125rem;
		overflow: hidden;
		display: flex;
		justify-content: flex-start;
		transition: background-color 0.15s;

		.placeholder {
			text-align: left;
			color: var(--default-disabled-btn-1);
			font-weight: 200;
		}

		.display {
			color: var(--default-disabled-btn-2);
		}

		&:hover {
			cursor: pointer;
			background-color: rgb(244, 244, 244);
		}
	}

</style>
